<template>
  <v-app :class="'lang-' + locale">
    <v-app-bar color="primary" app>
      <v-toolbar-title>
        <router-link
          class="white--text text-decoration-none fill-height"
          to="/"
        >
          <v-img
            width="50"
            height="40"
            src="@/assets/OneandAll_pms583.png"
          ></v-img>
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <LangSelect />
        <UserMenu v-if="user" v-bind:user="user" v-bind:locale="locale" />
      </v-toolbar-items>
    </v-app-bar>

    <v-main>
      <v-container class="fill-height" fluid>
        <router-view v-if="user" v-bind:user="user"></router-view>
        <router-view v-else> </router-view>
      </v-container>
    </v-main>

    <v-footer color="accent" app>
      <span class="primary--text"
        >&copy; OneAndAll {{ new Date().getFullYear() }}</span
      >
    </v-footer>
    <v-dialog v-model="chooseLanguageDialog" max-width="525">
      <template>
        <v-card>
          <v-card-title>
          </v-card-title>
          <v-card-text>
            <p>
              <strong>{{ chooseLanguageDialogText['sv'].title }}</strong><br>
              {{ chooseLanguageDialogText['sv'].text }}
            </p>
            <p>
              <strong>{{ chooseLanguageDialogText['en'].title }}</strong><br>
              {{ chooseLanguageDialogText['en'].text }}
            </p>
            <p>
              <strong>{{ chooseLanguageDialogText['ar'].title }}</strong><br>
              {{ chooseLanguageDialogText['ar'].text }}
            </p>
            <v-btn v-for="(language, i) in languages"
                :key="i" @click="setLocale(language); chooseLanguageDialog = false" style="margin: 0.5rem;" color="primary" v-text="language.text"></v-btn>
          </v-card-text>

        </v-card>
      </template>
    </v-dialog>
  </v-app>
</template>

<script>
import LangSelect from "@/components/standalone/LangSelect.vue";
import UserMenu from "@/components/standalone/UserMenu.vue";
import { auth, db } from "@/common/firebase.js";
import store from "@/store/index.js";

export default {
  components: {
    LangSelect,
    UserMenu
  },
  data() {
    return {
      chooseLanguageDialog: true,
      chooseLanguageDialogText: {
        sv: {
          title: "Välj instruktionsspråk",
          text:
            "Välj det språk du läser bäst på."
        },
        en: {
          title: "Select instructional language",
          text: "Select the language you are most comfortable to read in."
        },
        ar: {
          title: "أختر لغة الإرشادات",
          text: ".اختر اللغة التي تقرأ بالشكل الأفضل بها"
        }
      },
      languages: [
        { text: "Svenska", value: "sv" },
        { text: "English", value: "en" },
        { text: "العربية", value: "ar" }
      ]
    }
  },
  methods: {
    setLocale(val) {
      this.$store.commit("SET_LOCALE", val);
    }
  },
  watch: {
    fullPath() {
      if(this.locale === "ar" && this.fullPath !== "/assessment/D1" && this.fullPath !== "/assessment/D3"){
        this.$vuetify.rtl = true;
      }else{
        this.$vuetify.rtl = false;
      }
    },
    locale() {
      if(this.locale === "ar" && this.fullPath !== "/assessment/D1" && this.fullPath !== "/assessment/D3"){
        this.$vuetify.rtl = true;
      }else{
        this.$vuetify.rtl = false;
      }
    }
  },
  computed: {
    fullPath: function() {
      return this.$route.fullPath;
    },
    locale() {
      return this.$store.getters.GET_LOCALE.value;
    },
    user() {
      return this.$store.getters["user/GET_USER"];
    }
  },
  beforeCreate() {
    auth.onAuthStateChanged(user => {
      if (user !== null) {
        store.commit("user/SET_FIREBASE_USER", {
          uid: user.uid,
          email: user.email,
          name: user.displayName
        });
        db.collection("users")
          .doc(user.uid.toString())
          .get()
          .then();
      } else {
        store.commit("user/SET_FIREBASE_USER", false);
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.lang-ar {
  font-size: 18px;
  
}
</style>
